<script setup lang="ts">
/**
 * CaLockup — mark + wordmark CoreAsia.
 *
 * Mark ditulis inline sebagai SVG, bukan <img>: ~1 KB, nol permintaan jaringan,
 * dan latar squircle-nya sudah gelap tetap (tidak perlu ikut mode gelap situs).
 * Gradiennya gold → teal, mengikuti gradien yang sudah dipakai berkas logo
 * CoreAsia — teal #1BC49E itu bagian dari identitas aslinya, bukan tambahan.
 *
 * Bentuk (lingkaran + centang) DITELUSUR dari public/logos/coreasia-beres.png
 * — sumber yang sama dipakai untuk favicon (lihat nuxt.config.ts app.head.link
 * dan deploy/CLOUDFLARE.md). Sebelumnya mark di sini berupa arc "C" + titik
 * yang tidak cocok dengan logo asli; jangan digambar ulang tanpa membandingkan
 * ke berkas itu lagi.
 */
withDefaults(
  defineProps<{
    /** Sembunyikan wordmark, sisakan mark saja (mis. di bilah sempit). */
    markSaja?: boolean
    ukuran?: 'sm' | 'md'
  }>(),
  { ukuran: 'md' }
)

// id gradien harus unik per instans supaya dua lockup di satu halaman
// (header + footer) tidak saling menimpa definisi <defs>-nya.
const uid = useId()
</script>

<template>
  <span class="inline-flex items-center gap-2.5 min-w-0">
    <svg
      :class="ukuran === 'sm' ? 'size-7' : 'size-9'"
      class="shrink-0"
      viewBox="0 0 44 44"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient :id="`ca-mark-${uid}`" x1="10" y1="31" x2="33" y2="10" gradientUnits="userSpaceOnUse">
          <stop stop-color="#FFBE3D" />
          <stop offset="0.6" stop-color="#FFD670" />
          <stop offset="1" stop-color="#1BC49E" />
        </linearGradient>
        <radialGradient :id="`ca-mark-bg-${uid}`" cx="0.3" cy="0.2" r="1">
          <stop stop-color="#1A2445" />
          <stop offset="1" stop-color="#050814" />
        </radialGradient>
      </defs>
      <!-- squircle: rx 22,7% dari sisi, sesuai bentuk mark resmi -->
      <rect width="44" height="44" rx="10" :fill="`url(#ca-mark-bg-${uid})`" />
      <!-- Cincin + centang, sama seperti public/logos/coreasia-beres.png:
           ekor centang sengaja melewati tepi cincin di kanan-atas. -->
      <circle cx="21" cy="22.5" r="9.2" :stroke="`url(#ca-mark-${uid})`" stroke-width="3.6" fill="none" />
      <path
        d="M14.6 22 L19.4 27.4 L30.8 12.6"
        :stroke="`url(#ca-mark-${uid})`"
        stroke-width="4.3"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>

    <span
      v-if="!markSaja"
      class="font-display font-extrabold tracking-tight text-ink truncate"
      :class="ukuran === 'sm' ? 'text-base' : 'text-lg'"
    >CoreAsia <span class="text-brand">Beres</span></span>
  </span>
</template>
